import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';
import AlarmList from './components/AlarmList';
import axios from "@/plugins/axios";
import TimeLine from "@/components/TimeLine";
import Alarm from "@/components/Alarm";
import BackOffice from "@/components/BackOffice";
import Notification from "@/components/Notification";
import Info from "@/components/Info";
import TimeLineItem from "@/components/TimeLineItem";

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import TimeComponent from "@/components/TimeComponent";


Vue.config.productionTip = false
Vue.prototype.$http = axios;


Vue.use(VueRouter);
Vue.use(axios);
//Vue.components('timeline')
// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
    { path: '/todos', component: AlarmList },
    { path: '/history', component: TimeLine },
    { name: 'alarm', path: '/alarm', component: Alarm },
    { name: 'notification', path: '/notification', component: Notification },
    { path: '/', component: AlarmList},
    { path: '/admin', component: BackOffice },
    { name: 'info', path: '/info', component: Info },
    { name: 'timelineItem', path: '/timeline-item', component: TimeLineItem}
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
    routes // short for `routes: routes`
})

new Vue({
    vuetify,
    axios,
     router,
    components: {
      'timeline' : TimeComponent
    },
    render: h => h(App)
}).$mount('#app')
